/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { getOrganizationPropertiesByHost } from '../../../utils/helpers';
import ViewAllButton from './ViewAllButton';
import HorizontalScroll from '../../shared/HorizontalScroll';
import Tags from './Tags';
import CoursesCard from '../../shared/CoursesCard';
import Spinner from '../../shared/spinner';
import { useMiscellaneousData } from '../../../contexts/ssr-miscellaneous-context';

function OnlineCourses({
  onlineLoading,
  // eslint-disable-next-line no-unused-vars
  refetchOnlineCourses, heading, onlineData, centerSelected, order, initialTagsData,
}) {
  const [onlineTagSelected, setOnlineTagSelectd] = useState('');
  const { miscellaneousData } = useMiscellaneousData();
  const currentOrg = getOrganizationPropertiesByHost(miscellaneousData?.hostname);
  const organizationId = currentOrg?.orgId || '2410f924-6cc4-4e88-b490-ffd3bbc40d03';
  const [centerID] = useState(centerSelected);

  const handleTagsCourse = (tagType, tagId) => {
    setOnlineTagSelectd(tagId === 'all' ? '' : tagId);
    refetchOnlineCourses({
      variables: {
        orgId: organizationId,
        filters: [
          {
            key: 'centreId',
            value: '',
          },
          {
            key: 'tagId',
            value: tagId === 'all' ? '' : tagId,
          },
          {
            key: 'mode',
            value: 'Online',
          },
        ],
      // fetchPolicy: 'cache-first',
      },
    });
  };
  return (
    <div className="mt-12">
      <div className="flex justify-between items-center mb-4 lg:mb-7">
        {/* eslint-disable-next-line eqeqeq */}
        {/* {order == 1
                && <span className="text-sm lg:text-xl font-semibold text-customBlue">Our Courses</span>} */}
        <h2 className="text-base lg:text-2xl font-semibold">{heading}</h2>
      </div>
      {/* Filters */}
      {/* {getTagsOffline(responseData.getOrganizationById.tags)} */}
      <div className="flex justify-between items-center mb-4">

        <div className="w-full lg:w-[90%]">

          <HorizontalScroll rightSpace="lg:-right-7 right-1">
            <Tags
              organizationId={organizationId}
              typeTags="online"
              handleTagsCourse={handleTagsCourse}
              centerChange={centerID}
              initialTagsData={initialTagsData}
            />
          </HorizontalScroll>
        </div>

        <div className="mb-6 lg:mb-0">
          <ViewAllButton
            pageUrl="/all-courses"
            queryString={`?mode=${'Online'}&tag=${onlineTagSelected || 'all'}`}
            typeButton={2}
          />
        </div>
      </div>
      {!onlineLoading
        ? (
          <>

            <HorizontalScroll className="gap-2">
              <CoursesCard
                page="course"
                data={onlineData?.getCourses}
                otherProp="hello"
                wrapperClasses="flex gap-4"
              />
            </HorizontalScroll>

            {/* {onlineData?.getCourses.length ? ( */}
            <div className="lg:hidden mt-8">
              <ViewAllButton
                pageUrl="/all-courses"
                queryString={`?mode=${'Online'}&tag=${onlineTagSelected || 'all'}`}
              />
            </div>
            {/* ) : ''} */}
          </>
        )
        : <div className="min-h-80 flex justify-center items-center"><Spinner /></div>}

    </div>
  );
}

export default OnlineCourses;
